angular.module('acme.common.directive.resourceAvailability.constants',[])
.constant('AVAILABILITY', {
    available: {
      status: 'available',
      icon: 'fa-check',
      label: 'Available'
    },
    unavailable: {
      status: 'unavailable',
      icon: 'fa-exclamation',
      label: 'Unavailable'
    },
    unassign: {
      status: 'unassign',
      icon: 'fa-question',
      label: 'Unassigned'
    }
})
.constant('DROPDOWN', {
  classes: {
    view: 'resource-availability-resources-dropdown',
    edit: 'edit-mode'
  }
});
